// TODO: might move some of these to .env to prevent accidental misconfiguration

// TODO: wire these up per-environment
module.exports.default = {
  authnet: {
    dev: {
      login: '533QsfzHvp37',
      transaction: '9R8V9r48Txnv4TZm',
      client: '45s34Y3rwv7H4tn8dMYxSU29ZYzMrLpXZXGU9rGKKGz7tjJj6h2zEg7yvuT6YQzn'
    },
    // prod: {
    //   login: '7t6b6VVA',
    //   transaction: '2TuP8pg77D4r4N8D',
    //   client: '9gv3QySkFPG8eh7AKyJh4VvU5hc73yXrbQkPyE2JUGy73Bw42vCppt58T87de9Xd'
    // }
    prod: {
      login: '7p7tp4CC2L',
      transaction: '86Ce9v5Q9gW2RtEe',
      client: '8hJurL5ZWaXUfD3882XN74x9pYmyEVfp62tQBtRA2ntQfCYuyA2Cp63w99ve8H2P'
    }
    // prod: {
    //   login: '22Qaw86Eh',
    //   transaction: '6yZ85ZH9dVj448MU',
    //   client: '9wyAfKLnchaepHpRfr3TRCWu4yT9pHsyXGX65rh8VkT5T4G7DtV9fzF6D8S9tWdF'
    // }
  },
  paypal: {
    dev: 'AZwqhTsBOyY_R3VQrJYPgqsFQRI12-HC38QO8llvBVA9QK1UDju-Ms0rZZDjk_yeKANYAFAYE6G-Zl6w',
    prod: 'AXnDzjRvHoU0rmC7TjqsQEqpc_TkQ4aX3oukj3IlfiJ2lSM_xZN9IbM6lEbwGXZtvvqDRXc6qmhb9eiZ'
  }
}


// BE CAREFUL WITH THESE
// please don't touch unless you're sure you know what you're doing
module.exports.cartConfig = {
  testMode: false, // false for production
  skipAuthnet: false, // false for production
  skipGP: false // false for production
}

// if(module.hot) module.hot.accept()
